import React, {Fragment, useEffect, useState} from 'react';
import {EuiDatePicker, EuiDescribedFormGroup, EuiFieldText, EuiFormRow, EuiSelect} from "@elastic/eui";
import {identificationTypes} from "../../../app/models/identificaion-document-types";
import {useFormikContext} from "formik";
import moment from "moment";


const OrderFormBeneficiaryIdInfo = () => {
    const formik = useFormikContext();


    const[issueDate, setIssueDate]= useState<moment.Moment>()
    const[readonly, setReadonly]=useState<boolean>(false);
    const onIssueDateChanged = (date: moment.Moment)=>{
        formik.getFieldHelpers('IssueDate').setValue(date)
        setIssueDate(date)
    }

    useEffect(()=>{
       // setIssueDate(moment(formik.getFieldProps('IssueDate').value));
       /* if((formik.getFieldProps('Status').value))
        {
            if(formik.getFieldProps('Status').value == '2' ||
                formik.getFieldProps('Status').value == '3' ||
                formik.getFieldProps('Status').value == '4')
                setReadonly(true);
        }*/
    },[])

    return (
        <Fragment>
            <EuiFormRow label={'Type Of ID'}>
                <EuiSelect
                    {...formik.getFieldProps("TypeOfID")}
                    options={identificationTypes} disabled={readonly}></EuiSelect>
            </EuiFormRow>
            <EuiFormRow label={'Id Number'}>
                <EuiFieldText
                    {...formik.getFieldProps("IDNumber")} disabled={readonly} />
            </EuiFormRow>
            <EuiFormRow label={'Issue Date'}>
                <EuiDatePicker onChange={onIssueDateChanged} selected={issueDate} disabled={readonly} />
            </EuiFormRow>
            <EuiFormRow label={'Issue Place'}>
                <EuiFieldText
                    {...formik.getFieldProps("IssuePlace")} disabled={readonly} />
            </EuiFormRow>
            <EuiFormRow label={'Address'}>
                <EuiFieldText
                    {...formik.getFieldProps("Address")} disabled={readonly} />
            </EuiFormRow>
        </Fragment>
    );
};

export default OrderFormBeneficiaryIdInfo;